<template>

    <div class="bottomBoard">
        <div class="title">{{ floorData.floorTitle }}</div>
        <div class="girdArea" v-if="floorData.data.length > 0">
          <div v-for="(item,index) in floorData.data" :key="index" class="gird" @click="$jumpToPage(item)">
            <img class="girdImage" :src="item.imageUrl">
            <div class="girdSubTitle">{{ item.title }}</div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FourGrids',
  props: ['floorData']
}
</script>

<style lang="scss" scoped>
.bottomBoard
  {
    margin-top: 0.12rem;
    // margin-left: 0.1rem;
    // margin-right: 0.1rem;
    padding-top: 0.12rem;
    padding-bottom: 0.15rem;
    // background-color: white;
    box-shadow: 0px 1px 2px 1px rgba(153,153,153,0.04);
    border-radius: 0.08rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
      width: 95%;
      height: 0.21rem;
      font-family: PingFangSC-Medium;
      font-size: 0.15rem;
      color: #333333;
      letter-spacing: 0;
      text-align: left;
      font-weight: 500;
      padding: 0 0 0 0;
    }
    .girdArea
    {
      display: grid;
      width: 100%;
      grid-template-columns: auto auto auto auto;
      grid-gap: 0.1rem;
      margin-top: 0.12rem;
      .gird
      {
        width: 95%;
        // background: rgba(30,125,255,0.06);
        border-radius: 0.08rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .girdImage
        {
          width: 0.3rem;
          height: 0.3rem;
          margin-bottom: 0.075rem;
        }
        .girdSubTitle
        {
          height: 0.165rem;
          font-family: PingFangSC-Regular;
          font-size: 0.12rem;
          color: #333333;
          letter-spacing: 0;
          line-height: 0.165rem;
          font-weight: 400;
        }
      }
    }
}
</style>
